<!-- src/App.vue -->
<template>
  <div id="app">
    <!-- The current route’s component will appear here -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
}
</script>




